MOVE.UserActivity = (function (MOVE) {
  var NOT_FOR_SALE = 'not_for_sale';

  var init = function () {
  };

  var updateRecentSearches = function (data, updateItemsViewed) {
    var searchData = formatSearchData(data);

    if (!MOVE.LocalStorage.isAvailable) {
      return;
    }
    var recentSearches = getRecentSearches();

    var existingActivityData = existingSearchActivity(recentSearches, searchData);

    if (existingActivityData) {
      recentSearches = modifySearchData(searchData, updateItemsViewed);
    }
    else {
      recentSearches.push(searchData);
    }
    setLocalStorage('recent_searches', recentSearches);

    // Append criteria changed whenever search changes
    if (recentSearches.length === 1) {
      let criteriaVal = $.cookie('criteria'), newCriteriaVal;
      if (criteriaExcludesVal(criteriaVal, 'ns=1')) {
        newCriteriaVal = criteriaVal + '&ns=1'
      }
      updateCriteriaCookie(newCriteriaVal || criteriaVal)
    }

    if (recentSearches.length > 1) {
      let criteriaVal = $.cookie('criteria'), newCriteriaVal;
      if (criteriaExcludesVal(criteriaVal, 'cc=1')) {
        newCriteriaVal = criteriaVal.replace('ns=1', '')
        newCriteriaVal = newCriteriaVal + '&cc=1'
      }
      updateCriteriaCookie(newCriteriaVal || criteriaVal)
    }

    // Trigger custom event when search is updated
    $(document).trigger('recentSearchesUpdated');
  };

  var criteriaExcludesVal = function(criteriaVal, val) {
    return criteriaVal && !criteriaVal.includes(val)
  }

  var updateCriteriaCookie = function(val) {
    $.cookie('criteria', val, { domain: 'realtor.com', path: '/' })
  }

  var updateRecentViews = function (data, viewType) {
    if (!MOVE.LocalStorage.isAvailable) {
      return;
    }
    var viewData           = formatViewData(data, viewType),
        recentViews        = getRecentViews(),
        subResourceUpdated = localStorage.getItem('subResourceUpdated');

    if(_.isNull(subResourceUpdated)){
      recentViews = removeSubResourceForNFSAndNHC(recentViews);
      setLocalStorage('recent_views', recentViews);
      localStorage.setItem('subResourceUpdated', 'yes');
    }

    var existingActivityData = existingViewedActivity(recentViews, viewData);
    if (existingActivityData) {
      recentViews = modifyViewData(viewData);
    }
    else {
      recentViews.push(viewData);
    }
    setLocalStorage('recent_views', recentViews);

    // rendered from the server side
    // Trigger custom event when views is updated
    $(document).trigger('recentViewsUpdated');
  };

  var updateSrpListingClicked = function(data) {
    var listingData = {
        "rank": data.listingRanking,
        "src": data.dataSource,
        "featured": data.featured,
        };

    $.cookie("SrpClickedListing", JSON.stringify(listingData), {path: '/'});
  };

  var removeNullValues = function (data) {
    return _.omit(data, function (value) {
      return (_.isNull(value) || !_.isNumber(value) && _.isEmpty(value));
    });
  };

  var formatData = function(data) {
    const formattedData = formatPropTypes(data);
    return removeNullValues(formattedData.criteria.facets);
  };

  var formatPropTypes = function(data){
    var propType = data.criteria.facets.prop_type;
    data.prop_type = getFormattedPropertyType(propType);
    data.sub_prop_type =  getsubPropertyType(propType);
    return data;
  };

  var getFormattedPropertyType = function(propTypes){
    if(MOVE.FormatHelper.isEmpty(propTypes)){
      return 'single_family,condo,multi_family,farm,land';
    }
    var propertyTypes = propTypes.split(',');
    var formattedPropTypes = [];
    _.each(propertyTypes, function(value){
       formattedPropTypes.push(getPropertyTypeValue(value));
    });
    return _.reject(formattedPropTypes, _.isNull).join(',');
  };

  var getPropertyTypeValue = function(value){
    return MOVE.CONSTANTS.PROPERTY_TYPE_MAPPING[value] || value;
  };

  var getsubPropertyType = function(propType){
    if(MOVE.FormatHelper.isEmpty(propType) || propType === 'condo-townhome-row-home-co-op'){
      return 'condo,co_op,cond_op,townhouse';
    }
  };

  var getQuery = function (data) {
    var criteria = data.criteria;
    var facetObj = criteria.facets !== undefined ? formatData(data) : {};
    var mlsid = criteria.mlslid ? '#'+ criteria.mlslid : null;
    var street = criteria.school || criteria.school_district || criteria.university ? null : criteria.street;

    return removeNullValues(_.extend(facetObj, {
      city: criteria.city,
      state_code: criteria.state,
      postal_code: criteria.street ? null : criteria.postal,
      address: criteria.address,
      neighborhood: criteria.neighborhood,
      county: criteria.county,
      mlslid: mlsid,
      street: street,
      school: criteria.school,
      school_id: criteria.school_id,
      school_district: criteria.school_district,
      school_district_id: criteria.school_district_id,
      university: criteria.university,
      university_id: criteria.university_id,
      park: criteria.park,
      park_id: criteria.park_id,
    }));
 };

  var existingSearchActivity = function (existingActivity, data) {
    return _.find(existingActivity, function (i) {
      return (data.resource_type === i.resource_type && _.isEqual(data.query, i.query));
    });
  };

  var existingViewedActivity = function (existingActivity, data) {
    return _.find(existingActivity, function (i) {
      return (data.resource_id === i.resource_id && data.sub_resource_id === i.sub_resource_id);
    });
  };

  var formatSearchData = function (data) {
    var dataObj = {
      "items_viewed": 0,
      "first_ran": (new Date()).toISOString(),
      "last_ran": (new Date()).toISOString(),
      "resource_type": data.searchType,
      "query": getQuery(data),
      "search_type":data.criteria.searchType,
      "isAjax": data.isAjax || false
    };
    if (data.criteria.search_controller === 'Search::ForeclosuresController') {
      _.extend(dataObj, {distressed: 'foreclosure'});
    }
    if (data.criteria.search_controller === 'Search::NewConstructionController') {
      _.extend(dataObj, {new_construction: true});
    }
    return dataObj;
  };

  var formatViewData = function (data, viewType) {
    var viewData = {
      "views": 1,
      "last_viewed": (new Date()).toISOString(),
      "first_viewed": (new Date()).toISOString(),
      "resource_type": MOVE.CONSTANTS.LDP_PROPERTY_TYPES[viewType] || 'property',
      "resource_id": data.property_id
    };
    if(viewType !== NOT_FOR_SALE && viewType !== "new_community"){
      viewData.sub_resource_type = MOVE.CONSTANTS.LDP_SUB_PROPERTY_TYPES[viewType] || viewType;
      viewData.sub_resource_id   = data.listing_id;
    }

    return viewData;
  };

  var modifySearchData = function (data, updateItemsViewed) {
    var recentSearchesArray = getRecentSearches();
    return _.map(recentSearchesArray, function (i) {
      if (_.isEqual(data.query, i.query)) {
        if (updateItemsViewed) {
          i.items_viewed++;
        }
        i.last_ran = (new Date()).toISOString();
      }
      return i;
    });
  };

  var modifyViewData = function (data) {
    var recentViewsArray = getRecentViews();
    return _.map(recentViewsArray, function (i) {
      if (data.resource_id === i.resource_id && data.sub_resource_id === i.sub_resource_id) {
        i.views++;
        i.last_viewed = (new Date()).toISOString();
      }
      /* This will change existing elements in storage to "rental" which have been set to "for_rent" before the code change for
         CORE-7295.
       */
      if (typeof i.sub_resource_type  !== "undefined" && i.sub_resource_type  === 'for_rent') {
        i.sub_resource_type = 'rental';
      }
      return i;
    });
  };

  // update recent views for incorrect sub_resource_type:
  // new home community and not for sale(recently sold/off market/sell summary)
  var removeSubResourceForNFSAndNHC = function(recentViews){
    return _.map(recentViews, function (i) {
      if (i.sub_resource_type === NOT_FOR_SALE ||
          i.resource_type === MOVE.CONSTANTS.LDP_PROPERTY_TYPES.new_community) {
        delete i.sub_resource_type;
        delete i.sub_resource_id;
      }
      return i;
    });
  };

  var setLocalStorage = function (key, data) {
    localStorage.setItem(key, JSON.stringify(data));
  };

  var getRecentSearches = function () {
    if (!MOVE.LocalStorage.isAvailable) {
      return [];
    }
    var recentSearches = Array.isArray(fetchLocalStorage('recent_searches')) ? fetchLocalStorage('recent_searches') : JSON.parse(fetchLocalStorage('recent_searches').value);
    return recentSearches;
  };

  var getRecentViews = function () {
    if (!MOVE.LocalStorage.isAvailable) {
      return [];
    }
    var recentViews = Array.isArray(fetchLocalStorage('recent_views')) ? fetchLocalStorage('recent_views') : JSON.parse(fetchLocalStorage('recent_views').value);
    return recentViews;
  };

  var fetchLocalStorage = function (key) {
    if (localStorage.getItem(key) && localStorage.getItem(key) !== '') {
      return JSON.parse(localStorage.getItem(key));
    }
    else {
      localStorage.setItem(key, JSON.stringify([]));
      return JSON.parse(localStorage.getItem(key));
    }
  };

  var getSortedRecentSearches = function(){
    return MOVE.UserActivity.getRecentSearches().sort(function(a, b) {
      return new Date(b.last_ran) - new Date(a.last_ran);
    });
  };

  var getSortedRecentViews = function(){
    return MOVE.UserActivity.getRecentViews().sort(function(a, b) {
      return new Date(b.last_viewed) - new Date(a.last_viewed);
    });
  };

  var getSortedNonAjaxRecentSearches = function(){
    var recentSearches = getSortedRecentSearches();
    return _.select(recentSearches, function(search) {
      if(!search.isAjax || search.isAjax === undefined){
        return search;
      }
    });
  };

  MOVE.UserActivity =
  {
    init: init,
    updateRecentSearches: updateRecentSearches,
    updateRecentViews: updateRecentViews,
    updateSrpListingClicked: updateSrpListingClicked,
    getRecentSearches: getRecentSearches,
    getRecentViews: getRecentViews,
    getSortedRecentSearches: getSortedRecentSearches,
    getSortedNonAjaxRecentSearches: getSortedNonAjaxRecentSearches,
    getSortedRecentViews: getSortedRecentViews
  };
  return MOVE.UserActivity;

})(MOVE || {});



// WEBPACK FOOTER //
// ./shared_critical/user_activity.js